
import React, { Component } from "react";
import * as XLSX from 'xlsx';

//Import Breadcrumb
import { Row, Col, Card, CardBody, CardTitle, Button, FormGroup, Label } from "reactstrap"
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
  Fn_GetReport,
} from "../../store/functions";
import "../Masters/datatables.scss"
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

class InvoiceDetailedReport extends Component {
  constructor(props) {
    super(props);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const fromDate = new Date(currentYear, 3, 1); // April 1st of current year
    const toDate = new Date(currentYear + 1, 2, 31); // March 31st of next year

    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      page: 1,
      sizePerPage: 10,
      productData: [],
      selectedLedger: null,
      ledgerOptions: [],
      selectedCode: null,
      codeOptions: [],
      selectedItemType: null,
      itemTypeOptions: [],
      fromDate: fromDate,
      toDate: toDate
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Ledger";
    this.modalTitle = "Company Details";
    this.rtPage_Add = "AddLedger";
    this.rtPage_Edit = "EditLedger";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/LedgerMaster";
    this.API_URL1 = API_WEB_URLS.MASTER + "/0/token/ItemType";
    this.API_URL2 = API_WEB_URLS.MASTER + "/0/token/GetCodeArray";

    //Event Binding
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
    this.printReport = this.printReport.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    Fn_FillListData(this.obj, "Fillarray", this.API_URL + "/Id/0");
    Fn_FillListData(this.obj, "Fillarray1", this.API_URL1 + "/Id/0");
  }



  handleDropdownChange(selectedOption, dropdownType) {
    switch (dropdownType) {
      case 'ledger':
        this.setState({ selectedLedger: selectedOption });
        // Clear dependent dropdowns when ledger changes
        this.setState({ 
          selectedCode: null, 
          selectedItemType: null,
          codeOptions: [],
        });
        if (selectedOption) {
          Fn_FillListData(this.obj, "Fillarray2", this.API_URL2 + "/Id/" + selectedOption.value);
        }
        break;
      case 'code':
        this.setState({ selectedCode: selectedOption });
        break;
      case 'itemType':
        this.setState({ selectedItemType: selectedOption });
        break;
      default:
        break;
    }
  }

  handleFromDateChange(date) {
    this.setState({ fromDate: date });
  }

  handleToDateChange(date) {
    this.setState({ toDate: date });
  }

  handleSubmit = () => {
    const { selectedLedger, selectedCode, selectedItemType, fromDate, toDate } = this.state;
    console.log('Selected Values:', {
      ledger: selectedLedger,
      code: selectedCode,
      itemType: selectedItemType,
      fromDate: fromDate,
      toDate: toDate
    });

    // Format dates for SQL Server (YYYY-MM-DD)
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    let vformData = new FormData();
    // If no ledger is selected, send 0 as the Id
    vformData.append("F_LedgerMaster", selectedLedger ? selectedLedger.value : 0);
    vformData.append("CodeNo", selectedCode ? selectedCode.value : "");
    vformData.append("F_ItemTypeMaster", selectedItemType ? selectedItemType.value : 0);
    vformData.append("From", formatDate(fromDate));
    vformData.append("To", formatDate(toDate));
    Fn_GetReport(this.obj, {  arguList: {id: 0, formData: vformData } }, "InvoiceDetailReport/0/token", "gridData", true );
  }

  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }
  btnEdit_onClick(Id) {
    this.props.history.push(`${this.rtPage_Edit}/${Id}`, {});
  }
  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }

  exportToExcel = () => {
    const obj = JSON.parse( sessionStorage.getItem('authUser'))
    console.log(obj)
    if (this.state.gridData && this.state.gridData.length > 0) {
      // Prepare headers
      const headers = [
        'Invoice No',
        'Invoice Date',
        'Party Name',
        'PO No',
        'Code No',
        'Item Name',
        'Ply Name',
        'Quantity',
        'Rate',
        'Amount',
        'Gross Amount',
        'Tax Amount',
        'Net Amount'
      ];

      // Prepare data
      const data = this.state.gridData.map(item => [
        item.InvNo,
        item.InvDate,
        item.PartyName,
        item.PONo,
        item.CodeNo,
        item.ItemName,
        item.PlyName,
        item.Qty,
        item.Rate,
        item.Amount,
        item.GrossAmount,
        item.TaxAdd,
        item.NetAmount
      ]);

      // Combine headers and data
      const excelData = [headers, ...data];

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet(excelData);

      // Set column widths
      const wscols = [
        { wch: 15 }, // Invoice No
        { wch: 15 }, // Invoice Date
        { wch: 25 }, // Party Name
        { wch: 20 }, // PO No
        { wch: 20 }, // Code No
        { wch: 25 }, // Item Name
        { wch: 15 }, // Ply Name
        { wch: 12 }, // Quantity
        { wch: 12 }, // Rate
        { wch: 15 }, // Amount
        { wch: 15 }, // Gross Amount
        { wch: 15 }, // Tax Amount
        { wch: 15 }  // Net Amount
      ];
      ws['!cols'] = wscols;

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'InvoiceReport');

      // Save file
      XLSX.writeFile(wb, 'InvoiceDetailedReport.xlsx');
    }
  }

  printReport = () => {
    if (this.state.gridData && this.state.gridData.length > 0) {
      const printWindow = window.open('', '_blank');
      const obj = JSON.parse( sessionStorage.getItem('authUser'));
      
      // Create the print content
      const printContent = `
        <html>
          <head>
            <title>Invoice Detailed Report</title>
            <style>
              body { font-family: Arial, sans-serif; font-size: 11px; }
              table { width: 100%; border-collapse: collapse; margin: 20px 0; min-height: 65vh; }
              th, td { border: 1px solid #ddd; padding: 6px 4px; text-align: left; font-size: 10px; white-space: nowrap; }
              th { background-color: #f5f5f5; font-size: 10px; }
              .header { text-align: center; margin-bottom: 20px; }
              .date-range { margin-bottom: 20px; }
              @media print {
                .no-print { display: none; }
                body { font-size: 11px; padding: 0 10mm; }
                th, td { font-size: 10px; padding: 4px; }
                table { page-break-inside: auto; min-height: 75vh; }
                tr { page-break-inside: avoid; page-break-after: auto; }
                thead { display: table-header-group; }
                tfoot { display: table-footer-group; }
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h2>Invoice Detailed Report</h2>
              <div class="date-range">
                <strong>${obj.FirmName}</strong><br>
                From: ${this.state.fromDate.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                }).split('/').join('-')} To: ${this.state.toDate.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                }).split('/').join('-')}
                ${this.state.selectedLedger ? `<br>Ledger: ${this.state.selectedLedger.label}` : ''}
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Invoice No</th>
                  <th>Invoice Date</th>
                  <th>Party Name</th>
                  <th>PO No</th>
                  <th>Code No</th>
                  <th>Item Name</th>
                  <th>Ply Name</th>
                  <th>Quantity</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th>Gross Amount</th>
                  <th>Tax Amount</th>
                  <th>Net Amount</th>
                </tr>
              </thead>
              <tbody>
                ${this.state.gridData.map(item => `
                  <tr>
                    <td>${item.InvNo || ''}</td>
                    <td>${item.InvDate || ''}</td>
                    <td>${item.PartyName || ''}</td>
                    <td>${item.PONo || ''}</td>
                    <td>${item.CodeNo || ''}</td>
                    <td>${item.ItemName || ''}</td>
                    <td>${item.PlyName || ''}</td>
                    <td>${item.Qty || ''}</td>
                    <td>${item.Rate || ''}</td>
                    <td>${item.Amount || ''}</td>
                    <td>${item.GrossAmount || ''}</td>
                    <td>${item.TaxAdd || ''}</td>
                    <td>${item.NetAmount || ''}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
            <div class="no-print" style="text-align: center; margin-top: 20px;">
              <button onclick="window.print()">Print Report</button>
            </div>
          </body>
        </html>
      `;

      printWindow.document.write(printContent);
      printWindow.document.close();
    }
  }

  render() {
    // Map arrays to options directly in render
    const ledgerOptions = this.state.Fillarray ? this.state.Fillarray.map(item => ({
      value: item.Id,
      label: item.Name
    })) : [];
    
    const itemTypeOptions = this.state.Fillarray1 ? this.state.Fillarray1.map(item => ({
      value: item.Id,
      label: item.Name
    })) : [];
    
    const codeOptions = this.state.Fillarray2 ? this.state.Fillarray2.map(item => ({
      value: item.Id,
      label: item.Name
    })) : [];



    const columns = [{
      dataField: 'InvNo',
      text: 'Invoice No',
      sort: true,
      searchable: true
    }, {
      dataField: 'InvDate',
      text: 'Invoice Date',
      sort: true,
      searchable: true
    }, {
      dataField: 'PartyName',
      text: 'Party Name',
      sort: true,
      searchable: true
    }, {
      dataField: 'PONo',
      text: 'PO No',
      sort: true,
      searchable: true
    }, {
      dataField: 'CodeNo',
      text: 'Code No',
      sort: true,
      searchable: true
    }, {
      dataField: 'ItemName',
      text: 'Item Name',
      sort: true,
      searchable: true
    }, {
      dataField: 'PlyName',
      text: 'Ply Name',
      sort: true,
      searchable: true
    }, {
      dataField: 'Qty',
      text: 'Quantity',
      sort: true,
      searchable: true
    }, {
      dataField: 'Rate',
      text: 'Rate',
      sort: true,
      searchable: true
    }, {
      dataField: 'Amount',
      text: 'Amount',
      sort: true,
      searchable: true
    }, {
      dataField: 'GrossAmount',
      text: 'Gross Amount',
      sort: true,
      searchable: true
    }, {
      dataField: 'TaxAdd',
      text: 'Tax Amount',
      sort: true,
      searchable: true
    }, {
      dataField: 'NetAmount',
      text: 'Net Amount',
      sort: true,
      searchable: true
    }];

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.gridData,
      custom: true,
    }
    const selectRow = {
      mode: 'checkbox'
    }
    const { SearchBar } = Search;

    return (
      <div className="page-content">
        <Row className="mb-3">
          <Col md={3}>
            <FormGroup>
              <Label>Select Ledger</Label>
                             <Select
                 value={this.state.selectedLedger}
                 onChange={(option) => this.handleDropdownChange(option, 'ledger')}
                 options={ledgerOptions}
                 isSearchable={true}
                 placeholder="Select Ledger..."
               />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Select Code </Label>
                             <Select
                 value={this.state.selectedCode}
                 onChange={(option) => this.handleDropdownChange(option, 'code')}
                 options={codeOptions}
                 isSearchable={true}
                 placeholder="Select Code..."
               />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Select Item Type</Label>
                             <Select
                 value={this.state.selectedItemType}
                 onChange={(option) => this.handleDropdownChange(option, 'itemType')}
                 options={itemTypeOptions}
                 isSearchable={true}
                 placeholder="Select Item Type..."
               />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>From Date</Label>
              <DatePicker
                selected={this.state.fromDate}
                onChange={this.handleFromDateChange}
                className="form-control"
                dateFormat="dd/MM/yyyy"
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>To Date</Label>
              <DatePicker
                selected={this.state.toDate}
                onChange={this.handleToDateChange}
                className="form-control"
                dateFormat="dd/MM/yyyy"
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>&nbsp;</Label>
              <Button 
                color="primary" 
                className="w-100" 
                onClick={this.handleSubmit}
              >
                Submit
              </Button>
            </FormGroup>
          </Col>
        </Row>
        <PaginationProvider
          pagination={paginationFactory(pageOptions)}
          keyField='id'
          columns={columns}
          data={this.state.gridData}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField='id'
              columns={columns}
              data={this.state.gridData}
              search
              bootstrap4
            >
              {toolkitProps => (
                <React.Fragment>
                  <Row className="mb-2">
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar
                            {...toolkitProps.searchProps}
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          {this.state.gridData && this.state.gridData.length > 0 && (
                            <>
                              <Button 
                                color="success" 
                                className="btn-rounded waves-effect waves-light mb-2 mr-2"
                                onClick={this.exportToExcel}
                              >
                                <i className="mdi mdi-file-excel mr-1"></i> Export to Excel
                              </Button>
                              <Button 
                                color="info" 
                                className="btn-rounded waves-effect waves-light mb-2 mr-2"
                                onClick={this.printReport}
                              >
                                <i className="mdi mdi-printer mr-1"></i> Print Report
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField={"id"}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          selectRow={selectRow}
                          classes={
                            "table align-middle table-nowrap"
                          }
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone
                          {...paginationProps}
                        />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone
                          {...paginationProps}
                        />
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </div>
    );
  }
}
export default compose(container)(InvoiceDetailedReport);